/**
 * Created by Christof Sander on 25.01.2017.
 */

const utils = require('frontend-controller/lib/utils');

module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'form'
	],

	config: {
		resourceConnected: false
	},

	methods: {
		dataDealer: function(){
			var self = this;
			this.closest('templates_mediaManagement_imageAssignmentDetails_imageAssignmentDetails', function(imageAssignmentDetailsComponent){
				if(imageAssignmentDetailsComponent.resourceData && imageAssignmentDetailsComponent.resourceData.data){
					self.resourceData = {
						data: imageAssignmentDetailsComponent.resourceData.data
					};
				}
			});
		},

		onChange: function(){
			var self = this;
			this.closest('templates_mediaManagement_imageAssignmentDetails_imageAssignmentDetails', function(imageAssignmentDetailsComponent){
				imageAssignmentDetailsComponent.onChange(self.model.dirtyFields);
			});
		}
	}
};
